<template>
  <div class="grid grid-cols-12 clamp-gap-5-5">
    <ALink
      v-for="story in stories"
      :to="{ linktype: 'story', cached_url: getInternalUrl(story.full_slug) }"
      :key="story.uuid"
      class="col-span-12 tp:col-span-6 tl:col-span-4"
      v-if="!loading"
    >
      <ElementArticleCard
        class="w-full h-full"
        :date="story.content.date"
        :headlineText="story.content.title"
        :coverImage="story.content.media?.[0]"
        :articleContent="story.content.texts"
      />
    </ALink>
    <ElementArticleCardSkeleton v-else v-for="story in skeletonCardCount" />
  </div>
</template>

<script setup lang="ts">
import { MultilinkStoryblok } from '@/types';
import { ISbStoryData } from '@storyblok/vue';
import useConfig from '@/composables/useConfig';
import { TemplateArticleStoryblok } from '@/types';

interface Props {
  stories?: ISbStoryData<TemplateArticleStoryblok>[];
  skeletonCardCount: number;
  loading?: boolean;
  to?: MultilinkStoryblok;
}
const props = defineProps<Props>();
const { brand } = useConfig();

const getInternalUrl = (fullSlug: string): string => {
  let link = `/${brand.value}/news/${fullSlug.split('/').pop()}`;
  if (props.to && props.to.linktype === 'story') {
    if (import.meta.env.MODE.includes('editor')) {
      link = !link.startsWith(`/${brand.value}/`)
        ? `/${brand.value}${link}`
        : link;
    } else {
      if (link.startsWith(`/${brand.value}/`)) {
        link = link.replace(import.meta.env.VITE_STORYBLOK_BRAND_FOLDER, '');
      }
      link = link.startsWith('/') ? link : '/' + link;
    }
  }
  return link;
};
</script>
<style scoped></style>
